/* Collection subtitle — auto-split "X for Col Y" titles
   H1: strip suffix (breadcrumb shows hierarchy)
   Cards: split into main title + subtitle span */
(function () {
  var RE = /^(.+?)\s+for Col\s+(.+)$/;

  function stripH1(el) {
    var m = el.textContent.trim().match(RE);
    if (m) el.textContent = m[1];
  }

  function splitTitle(el) {
    var m = el.textContent.trim().match(RE);
    if (!m) return;
    el.textContent = m[1];
    var sub = document.createElement('span');
    sub.className = 'cus-collection-subtitle';
    sub.textContent = m[2];
    el.parentNode.insertBefore(sub, el.nextSibling);
  }

  /* Strip H1 as early as possible via MutationObserver */
  var observer = new MutationObserver(function (mutations) {
    var h1 = document.querySelector('h1');
    if (h1) {
      observer.disconnect();
      stripH1(h1);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Cards — process on DOMContentLoaded */
  function runCards() {
    observer.disconnect();
    document.querySelectorAll('h1').forEach(stripH1);
    document.querySelectorAll('.collection-card .text-block p, .collection-card .text-block span').forEach(splitTitle);
    document.querySelectorAll('.collection-card span.custom-typography').forEach(splitTitle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCards);
  } else {
    runCards();
  }
})();
